import { createReducer } from 'typesafe-actions';

import {
  IIntegrationConfigState,
  TIntegrationConfigAction,
  IntegrationConfigActionTypes,
} from '@/store/types/integration-config.types';

const initialState: IIntegrationConfigState = {
  onboardingUrl: { onboardingErrorCallBack: '', onboardingSuccessCallBack: '' },
  isLoading: false,
};

export const integrationConfigReducer = createReducer<IIntegrationConfigState, TIntegrationConfigAction>(initialState)
  .handleType(IntegrationConfigActionTypes.GET_ONBOARDING_URL, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(IntegrationConfigActionTypes.GET_ONBOARDING_URL_SUCCESS, (state, action) => {
    const onboardingUrl = action.onboardingUrl;

    return {
      ...state,
      onboardingUrl,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(IntegrationConfigActionTypes.GET_ONBOARDING_URL_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_SUCCESS, (state, action) => {
    const onboardingUrl = action.onboardingUrl;

    return {
      ...state,
      onboardingUrl,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(IntegrationConfigActionTypes.UPDATE_ONBOARDING_URL_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }));
